module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("List of Plates")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1.")]), _vm._v(" A Review at Hounslow Heath by Denis Dighton.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("2.")]), _vm._v(" The Crown & Thistle, Abingdon-on-Thames.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("3.")]), _vm._v(" The Cavalry Barracks at Canterbury.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("4.")]), _vm._v(" Dutch schuyts.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("5.")]), _vm._v(" A Surgeon and an Inspector of Hospitals.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("6.")]), _vm._v(" Study of Sir Frederick Ponsonby by Thomas Heaphy.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("7.")]), _vm._v(" Frederick Ponsonby’s Waterloo Sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("8.")]), _vm._v(" The 12th Light Dragoons by Denis Dighton.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("9.")]), _vm._v(" Captain William Hay, 12th Light Dragoons, circa 1820.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("10.")]), _vm._v(" A view of Quatre Bras on 19 June 1815 by Thomas Stoney, with corpses still littering the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("11.")]), _vm._v(" Farm of Quatre Bras just before it was shamefully destroyed.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("12.")]), _vm._v(" Courbevoie Barracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("13.")]), _vm._v(" The Waterloo Memorial to the 12th Light Dragoons. One of the first memorials to include the names of all ranks killed.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("14.")]), _vm._v(" Surgeon’s Regulation Case circa 1812.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("15.")]), _vm._v(" Chateau Marais, Argenteuil.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("16.")]), _vm._v(" Chateau Puteaux before its final destruction after a fire in 1881.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Plates#p17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("17.")]), _vm._v(" Chateau de Bacqueville.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766d896c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List.vue
// module id = 69
// module chunks = 0